import ChampionshipDetail from '@/apps/ChampionshipDetail'
import Layout from '@/apps/layout/components'
import React from 'react'

const ChampionshipDetailPage = (): React.ReactElement => {
  return (
    <Layout>
      <ChampionshipDetail />
    </Layout>
  )
}

export default ChampionshipDetailPage
